import { apiSlice } from 'api/apiSlice'

const passwordResetsApi = apiSlice.injectEndpoints({
  endpoints: build => ({
    forgotPassword: build.mutation({
      query: body => ({
        app: 'sneakers',
        data: body,
        method: 'POST',
        url: '/web-api/v1/password_resets/',
      }),
    }),
    resetPassword: build.mutation({
      query: body => ({
        app: 'sneakers',
        data: body,
        method: 'PATCH',
        url: `/web-api/v1/password_resets/${body?.password_resets?.reset_token}`,
      }),
    }),
  }),
})

export const { useForgotPasswordMutation, useResetPasswordMutation } = passwordResetsApi
